exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shapes, .Panel, .Log {\n  position: relative;\n  max-width: 684px;\n  margin: 16px 8px;\n  border: 2px solid lightgrey; }\n  .shapes h2, .Panel h2, .Log h2 {\n    position: absolute;\n    top: -36px;\n    left: 10%;\n    padding: 0 8px;\n    text-align: center;\n    background: white; }\n\n.Log {\n  position: fixed;\n  right: 0;\n  top: 0;\n  background: white;\n  z-index: 1;\n  margin: 16px; }\n\n.Panel {\n  max-width: 904px; }\n", ""]);

// exports
